import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import { formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import classNames from 'classnames';
import { domainName } from '../../../portal.config';
import Container from '../../../release/components/Container';

const drawerWidth = 520;
const styles = theme => ({
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '37%',// lấy chỉ số width ở drawer x 90%
        [theme.breakpoints.down('md')]: {
            width: '45%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '54%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    item_list: {
        marginBottom: theme.spacing(16)
    },
    boxItemContent: {
        padding: theme.spacing(3, 4, 3, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    item: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    listItem: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor: theme.palette.background.secondary
    },

    image_bg: {
        width: 40,
        height: 40,
        borderRadius: 40,
        backgroundColor: theme.palette.background.transparent
    },
    image: {
        width: 40,
        height: 40,
        resizeMode: 'contain'
    },

    status: {
        padding: theme.spacing(0, 3, 0, 3),
        //border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        // backgroundColor: '#25e709'
    },
    statusAdHoc: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        backgroundColor: theme.palette.background.other,
        color: theme.palette.text.onPrimary,
    },
    box: {
        padding: theme.spacing(2, 2, 0, 2)
    },
    state: {
        padding: theme.spacing(2, 0),
        margin: theme.spacing(1),
    },
});

class ServiceRequestsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            profileExpand: false,
        }
    }

    render() {
        const { classes, t, service_request, showLoading, handleLoadMore, hasMore, showLoadMore, onClickDetail, showDetail, transactionDetail, statusSeleted, setFilter } = this.props;
        console.log('service_request item= ', service_request)
        let service_requests = service_request && service_request.length > 0 ? service_request : [];
        //console.log("profile======== ", profileName)
        if (domainName == 'airlink') {
            return (
                <Container>
                    <Grid item xs={12}>
                        <Grid item xs={12} container>
                            <Grid item xs={12}>
                                <ButtonCustom color='primary' className={classes.button_Place} onClick={this.props.onShowNewServiceRequest} >{t('new_service_request')}</ButtonCustom>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.state}>
                            <Grid item xs={12} container spacing={2}>
                                <ButtonCustom size='xs' color={statusSeleted === 1 ? 'primary' : 'onPrimary'} onClick={() => setFilter(1)} >{t('New')}</ButtonCustom>
                                <ButtonCustom size='xs' color={statusSeleted === 2 ? 'primary' : 'onPrimary'} onClick={() => setFilter(2)} >{t('In Progress')}</ButtonCustom>
                                <ButtonCustom size='xs' color={statusSeleted === 3 ? 'primary' : 'onPrimary'} onClick={() => setFilter(3)} >{t('Responded')}</ButtonCustom>
                                <ButtonCustom size='xs' color={statusSeleted === 4 ? 'primary' : 'onPrimary'} onClick={() => setFilter(4)} >{t('Closed')}</ButtonCustom>
                            </Grid>
                        </Grid>
                        <Grid item container justify='center' alignItems='center'>
                            {showLoading && <CustomizedCircularProgress />}
                        </Grid>
                        {service_requests && <Grid xs={12} item>
                            <InfiniteScroll
                                dataLength={service_requests.length} //This is important field to render the next data
                                next={handleLoadMore}
                                hasMore={hasMore}
                                loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                            // height={window.innerHeight}
                            >
                                <Grid xs={12} item container className={classes.item_list}>
                                    {service_requests.map((item, index) => {
                                        return (
                                            <Grid xs={12} sm={4} key={index} item style={{ padding: 10 }}>
                                                <ServiceRequestsItem classes={classes} key={index}
                                                    item={item} onClickDetail={onClickDetail}
                                                    showDetail={showDetail}
                                                    transactionDetail={transactionDetail} />
                                            </Grid>
                                        );
                                    }
                                    )}
                                </Grid>
                            </InfiniteScroll>
                        </Grid>}
                    </Grid>
                </Container>
            );
        }
        else {
            return (
                <div>
                    <DrawerCustom
                        open={this.props.open}
                        onClose={this.props.onClose}
                        title={t('service_requests')}
                        children={
                            <Grid item>
                                <Grid item container justify='center' alignItems='center'>
                                    {showLoading && <CustomizedCircularProgress />}
                                </Grid>
                                {service_requests && <Grid xs={12} item>
                                    <InfiniteScroll
                                        dataLength={service_requests.length} //This is important field to render the next data
                                        next={handleLoadMore}
                                        hasMore={hasMore}
                                        loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                        height={window.innerHeight}
                                    >
                                        <Grid xs={12} item className={classes.item_list}>
                                            {service_requests.map((item, index) => <ServiceRequestsItem classes={classes} key={index}
                                                item={item} onClickDetail={onClickDetail}
                                                showDetail={showDetail}
                                                transactionDetail={transactionDetail} />
                                            )}
                                        </Grid>
                                    </InfiniteScroll>
                                </Grid>}
                                <Grid item xs={12} className={classes.footer} container>
                                    <Grid item xs={12}>
                                        <ButtonCustom fullWidth color='primary' className={classes.button_Place} onClick={this.props.onShowNewServiceRequest} >{t('new_service_request')}</ButtonCustom>
                                    </Grid>
                                </Grid>
                            </Grid>
                        } />
                </div>
            );
        }
    }
}

function ServiceRequestsItem(props) {
    const { item, classes } = props
    const status = item.status
    const css = {
        new: {
            backgroundColor: '#25e709'
        }

    }
    var showDetail = props.showDetail && props.transactionDetail && props.transactionDetail.id && props.transactionDetail.id === item.id;
    return (
        <div>
            <Grid xs={12} item container className={classes.boxItemContent} onClick={() => props.onClickDetail(item)}>
                <Grid xs={12} item container direction='row'>
                    <Grid item xs={6}>
                        <CustomTypo mg_top_sm variant='body2' color='secondary'>{item.created_date ? formatDateToDDMMYYYYHHSSFrEpoch(item.created_date) : ""}</CustomTypo>
                    </Grid>

                    <Grid item xs={6} container justify='flex-end' >
                        <Grid item style={{ backgroundColor: status.colour }} className={classes.status}>
                            <CustomTypo color='onPrimary'>{status.name ? status.name : ''}</CustomTypo>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid xs={12} item container alignItems='center'>
                    <Grid xs={12} item>
                        <CustomTypo variant='subtitle2'>{item.number ? item.number : ""}</CustomTypo>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.box}>
                    {item.classification && <Grid item xs={12} className={classes.box}>
                        <Grid item xs={12}>
                            <CustomTypo variant='button'>{t('classification')}</CustomTypo>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo variant='description'>{item.classification ? item.classification : ''}</CustomTypo>
                        </Grid>
                    </Grid>}
                    <Grid item xs={12} className={classes.box}>
                        <Grid item xs={12}>
                            <CustomTypo variant='button'>{t('description')}</CustomTypo>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo variant='description'>{item.description}</CustomTypo>
                        </Grid>
                    </Grid>
                    {status.name === 'Closed' && <Grid item xs={12} className={classes.box}>
                        <Grid item xs={12}>
                            <CustomTypo variant='button'>{t('closure_reason')}</CustomTypo>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo variant='description'>{item.closure_reason && item.closure_reason.name ? item.closure_reason.name : ''}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {item.response && <Grid item xs={12} className={classes.box}>
                        <Grid item xs={12}>
                            <CustomTypo variant='button'>{t('response')}</CustomTypo>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo variant='description'>{item.response}</CustomTypo>
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </div>
    )
}
export default withStyles(styles)(withTranslation()(ServiceRequestsView));